export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "叮咚漫画网的新作多久更新一次？",
    a: "叮咚漫画网坚持每日更新新作列表，热门新番与独家内容会第一时间上架速递。每周三和周五为新作集中首发时段，其余时间也会根据作品排期随时上新，确保你永远快人一步看到最新内容。",
  },
  {
    q: "独家抢先看的作品和其他网站有什么不同？",
    a: "叮咚漫画网的独家内容意味着你在其他平台无法率先看到，我们与多位作者和版权方合作，为读者争取首发与抢先看的权益。独家作品会在站内特别标注「独家首发」标识，更新进度通常领先全网。",
  },
  {
    q: "如何第一时间收到新番上架提醒？",
    a: "你可以在首页底部订阅叮咚漫画网的新作资讯邮件，订阅后每次新番上架或独家首发时，我们都会第一时间推送提醒。同时也可以关注站内「新番速递」板块，实时查看每日上新动态。",
  },
  {
    q: "作品更新进度在哪里查看？",
    a: "每部作品的详情页都会展示最新章节、更新时间和连载状态。在「作品库」和「新作速递」列表中，我们也会同步展示最新话数与最近更新时间，方便你快速掌握追更进度。",
  },
  {
    q: "是否可以按分类筛选自己想看的漫画？",
    a: "当然可以。叮咚漫画网的「作品库」支持按热血冒险、玄幻仙侠、校园青春、都市职场、悬疑烧脑、科幻机甲、搞笑日常、恋爱治愈等分类筛选，并支持按热度、评分和更新时间排序，帮助你快速找到心仪的作品。",
  },
  {
    q: "叮咚漫画网的内容可以免费阅读吗？",
    a: "叮咚漫画网坚持内容品质与用户体验并重，大部分新作和独家内容均提供免费试读章节。具体的阅读权限与更新节奏会在每部作品的详情页清楚说明，让每一位读者都能安心追更。",
  },
];